// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__t7N4P","search":"Settings_search__qusvI","filter":"Settings_filter__2xLCV"};